import React from 'react'
import { func } from 'prop-types'
import { translate } from 'react-i18next'
import { NewInquiryButton } from './buttons/NewInquiryButton'
import './NewInquiryBanner.css'

const NewInquiryBannerComponent = ({ t }) => (
  <div className='new-inquiry-banner'>
    <div className='new-inquiry-banner__content'>
      <p className='new-inquiry-banner__title'>{t('common:visits:new_request_banner_title')}</p>
      <p className='new-inquiry-banner__text'>{t('common:visits:new_request_banner_text')}</p>
    </div>
    <NewInquiryButton />
  </div>
)

NewInquiryBannerComponent.propTypes = {
  t: func
}

export const NewInquiryBanner = translate()(NewInquiryBannerComponent)



// WEBPACK FOOTER //
// ./src/components/ui/NewInquiryBanner.js